<!--
  <img src="{{ user?.avatar }}">
<div>
  <h4>{{ user?.name }}  </h4>
   
</div>
-->
 
<div *ngIf="chat" class="chat-wrapper">

  <div *ngIf="loggined && !banned"  class="logout-link" (click)="logout()">

  <nb-icon  [icon]="'log-out'" pack="eva" status="basic"></nb-icon>

  </div>
  
  
  <div *ngIf="!loggined && !banned && !logginMode"  class="logout-link"  (click)="logginMode = true">
 
  <a href="javascript:;">Login</a>

  </div>

                     
                    <!-- [avatar]="msg.user.avatar" -->
 <nb-chat [class.padbottom]="!loggined && !banned" [noMessagesPlaceholder]="'No messages yet.'" [title]="'Chat' + (user?.name ? ': '+user?.name : '')"  >
    <nb-chat-message *ngFor="let msg of messages"
    
    		      [class.fromOwner]="msg.fromOwner || false"
                     [dateFormat]="'(yyyy-MM-dd HH:mm:ss)'"
                     [type]="msg.type"
                     [message]="msg.text"
                     [reply]="msg.reply"
                     [sender]="msg.user.name"
                     [date]="msg.date"  
		     [avatar]="false"
			 >
    </nb-chat-message>
    <nb-chat-form *ngIf="loggined  && !banned"  [messagePlaceholder]="'Type a message'" (send)="sendMessage($event)" [dropFiles]="true">
    </nb-chat-form>
    </nb-chat> 

    <div *ngIf="!loggined && !banned && logginMode" class="login-panel">
    
    <div style="position:absolute; top:7px; right:7px"   (click)="logginMode = false">  
     <nb-icon  style="color:#598bff; cursor:pointer" [icon]="'close'" pack="eva" status="basic"></nb-icon>
    </div>

	<div *ngIf="stream.chatNonameEnabled" style="display:flex"> 
		<div  style="display:flex; flex:1; margin-right:15px;"><input [class.error]="enterByLoginError" #enterByLoginInput nbInput fullWidth placeholder="Enter your name"  /></div> 
		<div><button nbButton status="primary" (click)="enterByLogin(enterByLoginInput.value)" >Enter</button></div>

		</div>
        
      <div *ngIf="!emailPanel && !stream.chatNonameEnabled" class="login-buttons">
      <button nbButton status="primary" (click)="openEmailEnterPanel()" >EMAIL</button>
      <button nbButton status="primary"  (click)="login()">Social network</button> <!-- -->

      </div>

      <div *ngIf="emailPanel  && !stream.chatNonameEnabled" > 
          <app-watcher-chat-elogin (onLogin)="loginByEmail($event)" (onCancel)="emailPanel = false"  ></app-watcher-chat-elogin>
      </div>
    
  </div>

  </div>
